module.exports = __webpack_public_path__ + "img/cb514f5.png";